import React from "react";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";

import { colors } from "utils/styles";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF } from "@fortawesome/free-brands-svg-icons/faFacebookF";
import { faLinkedin } from "@fortawesome/free-brands-svg-icons/faLinkedin";
import { faYoutube } from "@fortawesome/free-brands-svg-icons/faYoutube";
import { faTwitter } from "@fortawesome/free-brands-svg-icons/faTwitter";
import DynamicLink from "components/Reusables/DynamicLink";
// library.add(faFacebookF, faLinkedin, faYoutube, faTwitter);

const careerLinks = [
	{
		text: "Take the leadership self-assessment",
		link: "/assessment",
	},
	{
		text: "The AAPL Experience",
		link: "/education/experience",
	},
	{
		text: "Leadership Basics & Early Career",
		link: "/education/early-career",
	},
	{
		text: "Advanced & C-Level",
		link: "/education/c-level",
	},
	{
		text: "Find CME Courses",
		link: "/education/courses",
	},
	{
		text: "Events",
		link: "/events",
	},
	{
		text: "Reaching CPE Status",
		link: "/credentials/cpe",
	},
	{
		text: "Master's Programs",
		link: "/credentials/masters",
	},
	{
		text: "Fellowship (FAAPL)",
		link: "/credentials/fellowship",
	},
	{
		text: "Coaching & Mentoring",
		link: "/membership/mentoring",
	},
	{
		text: "Job Board",
		link: "https://jobsearch.physicianleaders.org/",
	},
	{
		text: "AAPL Solutions for Organizations & Teams",
		link: "/aapl-solutions",
	},
];

const resourceLinks = [
	{
		text: "Physician Leadership White Paper",
		link: "/whitepaper",
	},
	{
		text: "Articles & Guides",
		link: "/articles/topics",
	},
	{
		text: "Newsletter Sign Up",
		link: "/articles/newsletter-signup",
	},
	{
		text: "Free Wellness & Burnout Resources",
		link: "/resources/wellness/workplace-wellness",
	},
	{
		text: "Physician Leadership Journal (PLJ)",
		link: "/publications/plj",
	},
	{
		text: "Healthcare Administration Leadership & Management Journal (HALMJ)",
		link: "/publications/halmj",
	},
	{
		text: "The Journal of Medical Practice Management",
		link: "/publications/jmpm",
	},
	{
		text: "FAST Practice Newsletter",
		link: "/publications/fast-practice",
	},
	{
		text: "Shop Books",
		link: "/publications/books",
	},
	{
		text: "SoundPractice Podcast",
		link: "https://www.soundpractice.com/",
	},
	{
		text: "Contribute",
		link: "/publications/contribute",
	},
];

const communityLinks = [
	{
		text: "Benefits of Membership",
		link: "/membership",
	},
	{
		text: "Join or Renew",
		link: `${process.env.APP_URL}/membership/join`,
	},
	{
		text: "My Dashboard",
		link: `${process.env.APP_URL}/dashboard`,
	},
	{
		text: "Hear from Members",
		link: "/membership/testimonials",
	},
	{
		text: "Physician Leadership Connect",
		link: `${process.env.APP_URL}/community`,
	},
	{
		text: "Mentorship",
		link: "/membership/mentoring",
	},
	{
		text: "The Vanguard",
		link: "/programs/vanguard",
	},
	{
		text: "Fellowship (FAAPL)",
		link: "/credentials/fellowship",
	},
	// {
	// 	text: "Academies",
	// 	link: "/education/academies",
	// },
	{
		text: "Annual Leadership Conference",
		link: "/conference",
	},
	{
		text: "Fall Institute",
		link: "/fall-institute",
	},
];

const aboutLinks = [
	{
		text: "Our Story",
		link: "/about",
	},
	{
		text: "AAPL Leadership",
		link: "/about/leadership",
	},
	{
		text: "AAPL Board of Directors",
		link: "/about/board",
	},
	{
		text: "Key Faculty",
		link: "/about/faculty",
	},
	{
		text: "Partners & Sponsors",
		link: "/about/partners-and-sponsors",
	},
	{
		text: "Press Room",
		link: "/about/press-room",
	},
	{
		text: "Contact Us",
		link: "/contact",
	},
	// {
	// 	text: "Careers at AAPL",
	// 	link: "/aapl-jobs",
	// },
];

const FooterCol = (props) => {
	return (
		<Col md={6} lg={3}>
			<FooterLinks>
				<h2 className="sectionTitle mt-4 mb-3">{props.title}</h2>

				{props.links.map(({ text, link }, i) => {
					return (
						<React.Fragment key={i}>
							<DynamicLink classes="pb-2 d-block" href={link} text={text} color="white" />
						</React.Fragment>
					);
					// }
				})}
			</FooterLinks>

			<style jsx="true">{`
				.nav-link {
					padding: 0.5em 0em !important;
				}
				.sectionTitle {
					text-transform: uppercase;
					color: ${colors.yellow};
					margin: 0;
					font-size: 16px;
					font-family: "Open Sans";
					line-height: 36px;
					font-weight: 600;
				}
			`}</style>
		</Col>
	);
};
export default function Footer(props) {
	return (
		<Container fluid className="gx-0">
			<div ref={props.footerRef} className="px-4 pt-4 pb-5 footerLinksContainer">
				<Container fluid className="container-lg  pt-lg-5">
					<Row className="g-0">
						<FooterCol title="Career & Learning" links={careerLinks} />
						<FooterCol title="Leadership Library" links={resourceLinks} />

						<FooterCol title="Membership & Community" links={communityLinks} />

						<FooterCol title="About AAPL" links={aboutLinks} />
					</Row>
				</Container>
			</div>
			<div className="px-5 px-lg-5  pt-4 pb-5 footerHistoryContainer">
				<Container fluid className="container-lg  pt-lg-5">
					<Row>
						<Col lg={5}>
							<section className=" pt-3 pb-3">
								<h2 className="contactTitle pb-4">For over 50 years.</h2>
								<p className="contactText pb-4 pr-3">
									The American Association for Physician Leadership has helped physicians develop
									their leadership skills through education, career development, thought leadership
									and community building.
								</p>
								<p className="contactText pb-4">
									The American Association for Physician Leadership (AAPL) changed its name from the
									American College of Physician Executives (ACPE) in 2014. We may have changed our
									name, but we are the same organization that has been serving physician leaders since
									1975.
								</p>
							</section>
						</Col>
						<Col className="ps-lg-3 ps-xl-4 ps-xxl-5 " md={6} lg={3}>
							<section className=" pt-3 pb-3">
								<h2 className="contactTitle pb-4">CONTACT US</h2>
								<address className="contactText">Mail Processing Address</address>
								<address className="contactText">PO Box 96503 I BMB 97493</address>
								<address className="contactText pb-3">Washington, DC 20090-6503</address>
								<br />
								<address className="contactText">Payment Remittance Address</address>
								<address className="contactText">PO Box 745725</address>
								<address className="contactText pb-3">Atlanta, GA 30374-5725</address>

								<a className="contactText" href="tel:800-562-8088">
									<b>(800) 562-8088</b>
								</a>
								<br />
								<a className="contactText" href="fax:813-287-8993 ">
									(813) 287-8993
								</a>
								<span className="contactText"> Fax</span>
								<br />
								<a className="greenFont" href="mailto:customerservice@physicianleaders.org">
									customerservice@physicianleaders.org
								</a>
							</section>
						</Col>
						<Col md={6} lg={4}>
							<section className=" pt-3 pb-3">
								<h2 className="contactTitle pb-3">CONNECT WITH US</h2>
								<ul className="social-links ps-0">
									<li>
										<a
											href="https://www.facebook.com/PhysiciansLead/"
											className="social-icons"
											target="_blank"
										>
											<FontAwesomeIcon icon={faFacebookF} size="xs" />
										</a>
									</li>
									<li>
										<a
											href="https://twitter.com/Physicianslead"
											className="social-icons"
											target="_blank"
										>
											<FontAwesomeIcon icon={faTwitter} size="xs" />
										</a>
									</li>
									<li>
										<a
											href="https://www.linkedin.com/company/physicianslead/"
											className="social-icons"
											target="_blank"
										>
											<FontAwesomeIcon icon={faLinkedin} size="xs" />
										</a>
									</li>
									<li>
										<a
											href="https://www.youtube.com/user/physicianleaders"
											className="social-icons"
											target="_blank"
										>
											<FontAwesomeIcon icon={faYoutube} size="xs" />
										</a>
									</li>
								</ul>
							</section>

							<section className=" pt-5 pb-3">
								<h2 className="contactTitle pb-3">LOOKING TO ENGAGE YOUR STAFF?</h2>
								<p className="contactText pb-4">
									AAPL provides leadership development programs designed to retain valuable team
									members and improve patient outcomes.
								</p>
								<DynamicLink href="/aapl-solutions">
									<button type="button" className="btn-yellow btn btn-outline mb-5">
										AAPL Enterprise Solutions
									</button>
								</DynamicLink>
							</section>
						</Col>
					</Row>
					{/* copy right section */}
					<Row>
						<Col xs={12} lg={6}>
							<Row>
								<Col xs={12} className="">
									<Row className="g-0">
										<Col xs={12} xxl={"auto"}>
											<p className="contactText ">
												American Association for Physician Leadership{"\u{00A9}"}{" "}
												{/* <span className="px-xxl-2">|</span> */}
											</p>
										</Col>
										{/* <Col xs={12} xxl={"auto"}>
											<a className="greenFont" href="tel:800-562-8088">
												(800) 562-8088
											</a>
										</Col> */}
									</Row>
								</Col>
								<Col xs={12}>
									<p className="contactText pb-3 pe-3">
										formerly known as the American College of Physician Executives (ACPE)
									</p>
								</Col>
							</Row>
						</Col>
						<Col xs={12} lg={6}>
							<Row>
								<Col className="d-lg-flex justify-content-end pe-xl-5" xs={12}>
									<p className="contactText pb-3 pe-xl-5">
										<DynamicLink
											classes="px-1"
											href={"/privacy"}
											text={"Privacy Policy"}
											color={colors.green}
										/>
										|
										<DynamicLink
											classes="px-1"
											href={"/about/media-kit"}
											text={"Advertising Kit"}
											color={colors.green}
										/>
										|
										<DynamicLink
											classes="px-1"
											href={"/about/press-room"}
											text={"Press Room"}
											color={colors.green}
										/>
										|
										<DynamicLink
											classes="px-1 cookie-pref-trigger"
											onClick={() => window.Osano.cm.showDrawer("osano-cm-dom-info-dialog-open")}
											text={"Cookie Preferences"}
											color={colors.green}
										/>
									</p>
								</Col>
							</Row>
						</Col>
					</Row>
				</Container>
			</div>
			<style jsx="true">{`
				.footerLinksContainer {
					background: ${colors.darkBlue};
				}
				.footerHistoryContainer {
					background: ${colors.darkBlue2};
				}

				.contactTitle {
					text-transform: uppercase;
					color: ${colors.mediumGray};
					margin: 0;
					font-size: 16px;
					font-family: "Open Sans";
					line-height: 28px;
					font-weight: bold;
				}

				.contactText {
					color: ${colors.mediumGray};
					margin: 0;
					font-size: 14px;
					font-family: "Open Sans";
					line-height: 24px;
					font-weight: 400;
				}

				.greenFont {
					color: ${colors.green};
					margin: 0;
					font-size: 14px;
					font-family: "Open Sans";
					line-height: 24px;
					font-weight: 400;
					overflow-wrap: break-word;
				}

				.social-links {
					list-style: none;
					display: flex;
					margin-bottom: 0;
				}
				.social-icons {
					width: 30px;
					height: 20px;
					display: inline-flex;
					color: ${colors.white};
				}
				.btn-yellow {
					color: ${colors.white};
					border: 2px solid ${colors.yellow};
					border-radius: 5px;
					margin: 0;
					font-size: 15px;
					font-family: "Open Sans";
					line-height: 18px;
					font-weight: bold;
					padding: 16px 70px 16px 70px;
				}
			`}</style>
		</Container>
	);
}

function FooterLinks(props) {
	return (
		<section className="footerLinks px-4 px-lg-2 mb-5">
			{props.children}
			<style jsx="true">{`
				.footerLinks {
					color: ${colors.white};
					max-width: 300px;
				}
			`}</style>
		</section>
	);
}
